/** 文书内容排版：小四号（12pt），中文宋体 + 英文 Times New Roman，1.5 倍行距 */
export const CONTENT_FONT_SIZE_PT = 12;
export const CONTENT_FONT_SIZE_PX = 16;
export const CONTENT_LINE_HEIGHT_RATIO = 1.5;
export const CONTENT_LINE_HEIGHT_PX = Math.round(CONTENT_FONT_SIZE_PX * CONTENT_LINE_HEIGHT_RATIO);

export const CONTENT_FONT_FAMILY_CSS =
  '"Times New Roman", "Noto Serif", Times, "Noto Serif SC", "Songti SC", "STSong", "SimSun", serif';

export function buildContentDocumentFontLinksHtml() {
  return `
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link href="https://fonts.googleapis.com/css2?family=Noto+Serif+SC:wght@400;700&family=Noto+Serif:ital,wght@0,400;0,700;1,400&display=swap" rel="stylesheet" />
  `;
}

export function buildContentDocumentBodyCss(fontSizePx = CONTENT_FONT_SIZE_PX) {
  return `font-family: ${CONTENT_FONT_FAMILY_CSS}; font-size: ${fontSizePx}px; line-height: ${CONTENT_LINE_HEIGHT_RATIO};`;
}

export function buildContentDocumentPrintCss() {
  return `font-family: ${CONTENT_FONT_FAMILY_CSS}; font-size: ${CONTENT_FONT_SIZE_PT}pt; line-height: ${CONTENT_LINE_HEIGHT_RATIO};`;
}

export const documentMathTextClassName = 'document-math-text';
